module.exports = __webpack_public_path__ + "media/images/shared/ogp-angel-0a68bbc08eabbd5747585599eb196497.png";